<template>
	<div>
		<ui-radio-group
			v-if="priceTypeOptions.includes('FLAT')"
			v-model="priceType"
			name="priceType"
			radioValue="FLAT"
			:key="'true-' + priceType"
			label="Flat Price"
		/>
		<ui-radio-group
			v-if="priceTypeOptions.includes('INDEXED')"
			v-model="priceType"
			radioValue="INDEXED"
			name="priceType"
			:key="'false-' + priceType"
			label="Index-based Price"
		></ui-radio-group>
		<ui-radio-group
			v-if="priceTypeOptions.includes('BASIS')"
			v-model="priceType"
			name="priceType"
			radioValue="BASIS"
			:key="'False-' + priceType"
			label="Premium"
		></ui-radio-group>
	</div>
</template>

<script>
let options = require("../../cropOptions");
export default {
	props: {
		form: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			priceTypeOptions: ["FLAT", "INDEXED", "BASIS"],
		};
	},
	computed: {
		priceType: {
			get() {
				return this.form.price.type;
			},
			set(newValue) {
				this.form.price.type = newValue;
				if (newValue == "FLAT") {
					this.form.price.basis = null;
					this.form.price.commodity_future_id = null;
				} else {
					this.form.price.mt = null;
				}
			},
		},
	},
};
</script>
